// @flow
import $ from 'jquery'
import _ from 'lodash'
import React, { Component } from 'react'
import CoordinatesParser from './coordinates.parser'
import type { Point } from './google.map'
import FileUploadComponent from '../FileUploadComponent'

const wrongLinesCountToOutput = 7

type Props = {|
  minRadius: number,
  maxRadius: number,
  onLoad: (Array<Point>, string) => void
|}

const t = {
  coordinates_from_file: 'Координаты из файла',
  points_loaded: 'Загружено точек',
  lines_not_loaded: 'Некорректных строк',
  wrong_file_extension: 'Расширение файла не поддерживается'
}

export default class ImportFromFile extends Component<Props> {
  render() {
    return (
      <FileUploadComponent
        id="microlocations_file"
        browseText={t.coordinates_from_file}
        validExtensions={['.txt', '.csv']}
        onSuccessChange={(fileElement) => this.processFile(fileElement)}
        wrongExtensionText={t.wrong_file_extension}
      />
    )
  }

  processFile(input: any) {
    if (input.files.length) {
      let fileReader = new window.FileReader()
      fileReader.readAsText(input.files[0])
      $(fileReader).on('load', (e) => this.processFileReader(e))
    }
  }

  processFileReader(e: any) {
    let content = e.target.result
    if (content && content.length) {
      let parser = new CoordinatesParser(content, this.props.minRadius, this.props.maxRadius)
      let alertMessage = t.points_loaded + ': ' + parser.points.length
      if (parser.wrongLines.length > 0) {
        alertMessage += '. ' + t.lines_not_loaded + ': ' + parser.wrongLines.length + '\n'
        _.each(_.slice(parser.wrongLines, 0, wrongLinesCountToOutput), (line) => {
          alertMessage += '\n' + line
        })
        if (parser.wrongLines.length > wrongLinesCountToOutput) {
          alertMessage += '\n...'
        }
      }

      this.props.onLoad(parser.points, alertMessage)
    }
  }
}
